import { render, staticRenderFns } from "./AddNutritionForm.vue?vue&type=template&id=72c8cf7e&scoped=true"
import script from "./AddNutritionForm.vue?vue&type=script&lang=js"
export * from "./AddNutritionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8cf7e",
  null
  
)

export default component.exports